import { render, staticRenderFns } from "./CalcUserScore.vue?vue&type=template&id=ea3aaf10"
import script from "./CalcUserScore.vue?vue&type=script&lang=js"
export * from "./CalcUserScore.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports